import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "store/app-state";
import { setVisitId } from "store/user/user-action";
import ampliAnalytics from "services/amplitude/amplitudeAnalytics";

export const useTrackUser = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: IAppState) => state.user.currentUser);

  useEffect(() => {
    const deviceId = ampliAnalytics.getDeviceId();
    dispatch(setVisitId(deviceId ?? ""));
  }, []);

  useEffect(() => {
    if (user.username) {
      ampliAnalytics.identifyUser(user);
    }
  }, [user]);
};
